import "../../utils/tailwind.css";
import { PageProvider, useBlogsProvider } from "./provider";
import Label from "../../components/label";
import Section from "../../components/section";
import Tableloader from "../../components/table-loader";
import _ from "lodash";
import moment from "moment";

export default function AddUser() {
  return (
    <div className="p-3">
      <PageProvider>
        <PageContent />
      </PageProvider>
    </div>
  );
}

function PageContent() {
  const { getLeadsQuery, handlePageChange, currentPage } = useBlogsProvider();

  if (getLeadsQuery?.isPending) {
    return <Tableloader />;
  }

  const leads = getLeadsQuery?.data?.data?.data?.filter((v) => v.type === "demo") || [];
  const paging = getLeadsQuery?.data?.data?.paging || {};

  return (
    <Section className="h-[80vh] overflow-y-auto mt-5">
      <Label className="mb-0 text-black text-[16px] font-semibold" label="Demo Requests" />
      <div className="mt-3 overflow-x-auto mb-10">
        <table className="w-full min-w-[1300px] table-fixed border-collapse border border-gray-300 text-[14px]">
          <thead className="bg-gray-200">
            <tr>
              <th className="sticky left-0 z-10 bg-gray-200 border font-normal border-gray-300 px-2 py-2 text-left w-[60px]">SR No.</th>
              <th className="sticky left-[60px] z-10 bg-gray-200 border font-normal border-gray-300 px-2 py-2 text-left w-[160px]">Name</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[260px]">Work Email</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[140px]">Phone</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[160px]">Course Type</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[120px]">Pincode</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[180px]">Company Name</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[160px]">Designation</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[140px]">Country</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[140px]">City</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[180px]">Booking Slot</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[280px]">Message</th>
              <th className="border font-normal border-gray-300 px-2 py-2 text-left w-[280px]">Request Date</th>
            </tr>
          </thead>

          <tbody className="bg-white">
            {leads?.map((item, index) => (
              <tr key={index}>
                <td className="sticky left-0 z-[1] bg-gray-100 border border-gray-300 px-2 py-2 text-center truncate w-[60px]" title={`${index + 1}`}>
                  <Label className="mb-0 text-black text-[14px]" label={`${index + 1}.`} />
                </td>
                <td
                  className="sticky left-[60px] z-[1] bg-gray-100 border border-gray-300 px-2 py-2 truncate w-[160px]"
                  title={`${item.first_name} ${item.last_name}`}
                >
                  <Label className="mb-0 text-black text-[14px]" label={`${item.first_name} ${item.last_name}`} />
                </td>
                <td className="border border-gray-300 px-2 py-2 break-all" title={item.email}>
                  <Label className="mb-0 text-[14px]" label={item.email} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.phone}>
                  <Label className="mb-0 text-[14px]" label={item.phone} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.course_type}>
                  <Label className="mb-0 text-[14px]" label={_.startCase(_.toLower(item.course_type || "-"))} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.pincode}>
                  <Label className="mb-0 text-[14px]" label={item.pincode} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.company_name}>
                  <Label className="mb-0 text-[14px]" label={item.company_name} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.designation}>
                  <Label className="mb-0 text-[14px]" label={item.designation} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.country}>
                  <Label className="mb-0 text-[14px]" label={item.country} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.city}>
                  <Label className="mb-0 text-[14px]" label={item.city} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.booking_slot}>
                  <Label
                    className="mb-0 text-[14px]"
                    label={`${moment(item.contact_slot).format("DD/MM/YYYY")} - ${moment(item.contact_slot).format("hh:mm A")}`}
                  />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.message}>
                  <Label className="mb-0 text-[14px]" label={item.message} />
                </td>
                <td className="border border-gray-300 px-2 py-2 truncate" title={item.booking_slot}>
                  <Label className="mb-0 text-[14px]" label={`${moment(item.created_at).format("DD/MM/YYYY")}`} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        <div className="flex justify-end mt-4 pr-4">
          <div className="flex gap-2">
            {Array.from({ length: paging.total_pages || 1 }, (_, i) => i + 1).map((pageNo) => (
              <button
                key={pageNo}
                onClick={() => handlePageChange(pageNo)}
                className={`px-3 py-1 border rounded ${currentPage === pageNo ? "bg-black text-white" : "bg-white text-black"}`}
              >
                {pageNo}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Section>
  );
}
